<div class="flex items-center space-x-2">

  <button
    class="flex items-center space-x-2 px-4 py-2.5 text-sm font-semibold bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 active:translate-y-0 border-0"
    (click)="startTour()" [title]="'Start ' + tourTitle.toLowerCase()">
    <div class="flex items-center space-x-2">
      <lucide-icon [name]="tourIcon" class="w-4 h-4"></lucide-icon>
      <span class="hidden sm:inline">Tour</span>
      <span class="sm:hidden">Tour</span>
    </div>
  </button>


  <button *ngIf="showResetOption && hasSeenTour()"
    class="flex items-center space-x-1 px-2 py-2 text-xs text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200 rounded hover:bg-gray-50 dark:hover:bg-gray-700"
    (click)="resetTourSetting()" title="Show tour again on next visit">
    <lucide-icon name="refresh-cw" class="w-3 h-3"></lucide-icon>
    <span class="hidden sm:inline">Reset</span>
  </button>
</div>
